import { FC, useEffect, useState } from "react";
import Tree, { DefaultNode, useTreeState } from "react-hyper-tree";
import "./styles.scss";
import FlexBox from "../flex-box";
import { PiFileArchiveLight, PiFolderLight } from "react-icons/pi";
import LoadingBox from "../loading-box";
import ErrorBox from "../error-box";

export const CustomNode = ({ onNodeClick, ...props }) => {
  return (
    <FlexBox
      onClick={() => {
        onNodeClick(props?.node?.id);
      }}
      justifyContent="start"
      alignItems="center"
    >
      <>
        {props.node?.children?.length === 0 ? (
          <PiFileArchiveLight />
        ) : (
          <PiFolderLight />
        )}
      </>
      <DefaultNode
        {...props}
        node={props.node}
        onSelect={props.onSelect}
        onToggle={props.onToggle}
      />
    </FlexBox>
  );
};

interface SimpleTreeProps {
  nodes: TreeNode[];
  onNodeClick?: (nodeId: string) => void;
  nodeId?: string;
  className?: string;
  isLoading?: boolean;
  error?: string;
}

const SimpleTree: FC<SimpleTreeProps> = ({
  nodes,
  onNodeClick,
  nodeId,
  className,
  isLoading,
  error,
}) => {
  const [selectedNodeId, setSelectedNodeId] = useState<string | null>(nodeId);

  useEffect(() => {
    setSelectedNodeId(nodeId);
  }, [nodeId]);

  const treeId = "simple-tree-";

  const { required, handlers } = useTreeState({
    data: nodes,
    id: treeId,
    defaultOpened: true,
  });

  if (nodes?.length === 0) {
    return <p>No data available</p>;
  }

  if (error) return <ErrorBox message={error} />;

  return (
    <div className={className}>
      {isLoading ? (
        <LoadingBox />
      ) : (
        <Tree
          {...required}
          {...handlers}
          renderNode={(defaultProps) => {
            if (defaultProps.node?.id === selectedNodeId) {
              defaultProps.node.options.selected = true;
            } else {
              defaultProps.node.options.selected = false;
            }
            return (
              <CustomNode
                {...defaultProps}
                node={defaultProps.node}
                onNodeClick={(id) => {
                  if (id) {
                    onNodeClick?.(id as string);
                  }
                }}
              />
            );
          }}
        />
      )}
    </div>
  );
};

export default SimpleTree;
